module.exports = __webpack_public_path__ + "static/feature-user-e332a6b28ad9be07fb2503932ad3abf2.png";